var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextsketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 126,
    viewBox: "0 0 369 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.973 18.7635C225.732 -5.76982 113.741 -1.61926 56.2553 19.8486C30.075 29.6258 -18.2008 57.9555 11.1753 84.7023C16.3564 89.42 22.6544 93.2526 29.1704 96.569C100.882 133.066 200.901 129.349 277.863 107.511C289.341 104.254 300.636 100.388 311.027 95.1328C318.799 91.2026 326.313 86.3312 332.365 80.6464C350.082 64.0041 345.454 47.2558 326.392 33.1468C304.292 16.7884 274.07 11.719 245.553 8.94271C220.617 6.5151 195.712 6.04893 170.659 7.03971C123.672 8.89759 69.5231 11.8538 30.1152 34.2187C12.9029 43.9874 -5.58956 64.8614 9.16449 81.7559C25.1524 100.063 62.8501 105.991 88.2059 109.854C156.608 120.276 264.839 115.108 327.145 87.7595C333.863 84.8102 340.67 82.0617 346.68 78.1835C351.429 75.119 355.977 71.6248 359.921 67.8433C387.876 41.0439 325.497 24.1937 303.498 21.3C234.292 12.1968 131.862 -0.940081 68.1268 23.2761",
    stroke: "#00BA80",
    strokeWidth: 3,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextsketch);
export default __webpack_public_path__ + "static/media/textsketch.e7116df26edb4b69d91d6665d6d3606e.svg";
export { ForwardRef as ReactComponent };